import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import ProfileContent from "../profilecontent/profileContent";
import UserDetail from '../../../components/comment/userdetail/userDetail';

const createprofilecontent = () => {
  return (
    <div className="main-account create-profile-wrap">
    <Container className="main-account-content ">
      <Row className="main-content pt-4 pb-5">
        <Col lg={3} className="content-left acc-content-wrap">
          <ProfileContent />
        </Col>

        <Col lg={9} className="content-right  " >
        <UserDetail />
          {/* <AccountDetail />
          <PersonalDetail />
          <LocationDetail /> */}
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default createprofilecontent